import { render, staticRenderFns } from "./WinningRecord.vue?vue&type=template&id=51d6941f"
import script from "./WinningRecord.vue?vue&type=script&lang=js"
export * from "./WinningRecord.vue?vue&type=script&lang=js"
import style0 from "./WinningRecord.vue?vue&type=style&index=0&id=51d6941f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports